import { render, staticRenderFns } from "./ConfirmBuyingTenderEvaluation.vue?vue&type=template&id=fad7c906&"
import script from "./ConfirmBuyingTenderEvaluation.vue?vue&type=script&lang=ts&"
export * from "./ConfirmBuyingTenderEvaluation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports